import type { SVGProps } from "react";
const SvgStars = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g stroke="#fff" strokeLinejoin="round" clipPath="url(#stars_svg__a)">
      <path d="M2 8c3 0 6-3 6-6 0 3 3 6 6 6-3 0-6 3-6 6 0-3-3-6-6-6ZM1.333 13C1.89 13 3 11.889 3 11.333 3 11.89 4.111 13 4.667 13 4.11 13 3 14.11 3 14.667 3 14.11 1.889 13 1.333 13ZM10.667 3.333c.666 0 2-1.333 2-2 0 .667 1.333 2 2 2-.667 0-2 1.334-2 2 0-.666-1.334-2-2-2Z" />
    </g>
    <defs>
      <clipPath id="stars_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStars;
